<!--
 * @Descripttion: 
 * @Date: 2021-06-03 16:42:12
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-24 10:52:12
 * @Author: Sima thief
-->
<template>
  <div class="page">
    
    <el-table
      :data="beforeDetailOrdersDTO.beforDetailOrderDTOs"
      style="width: 100%"
    >
      <el-table-column prop="detailOrderNo" label="运单号" width="180">
      </el-table-column>
      <el-table-column prop="boxNo" label="箱号" width="180">
      </el-table-column>
      <el-table-column prop="goodsType" label="货物类型"> </el-table-column>
      <el-table-column prop="weight" label="重量（kg）" width="180">
      </el-table-column>
      <el-table-column prop="length" label="长度" width="180">
      </el-table-column>
      <el-table-column prop="width" label="宽度" width="180">
      </el-table-column>
       <el-table-column prop="height" label="高度" width="180">
      </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
                      <template slot-scope="scope">
                        <box-popover
                          :beforDetailOrderDTOs="scope.row.goodsDTOS"
                        ></box-popover>
                        <!-- {{scope.row}} -->
                      </template>
                    </el-table-column>

    </el-table>
 
    <div class="mr-top-10 btn">预报费用详情</div>
    <el-table
      :data="beforeDetailOrdersDTO.orderFeeDTOS"
      style="width: 100%"
    >
      <el-table-column prop="detailOrderNo" label="运单号" width="180">
      </el-table-column>
      <el-table-column prop="feeName" label="服务名称" width="180">
      </el-table-column>
      <el-table-column prop="num" label="数量"> </el-table-column>
      <el-table-column prop="price" label="单价"> </el-table-column>
      <el-table-column prop="currency" label="币种"> </el-table-column>
      <el-table-column prop="calcDesc" label="计算过程"> </el-table-column>
      <el-table-column prop="amount" label="总价"> </el-table-column>
    </el-table>
    
  </div>
</template>

<script>
import BoxPopover from "./BoxPopover.vue";
export default {
  name: "Fid",
  components:{
    BoxPopover
  },
  
  props: {
    beforeDetailOrdersDTO: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  
};
</script>
<style lang="scss" scoped>
@import "../styles/index.scss";
.all {
  height: 80px;
  line-height: 80px;
  background-color: rgba(242, 242, 242, 1);
}
.flex-item {
  text-align: center;
}
.text {
  font-size: 16px;
}
.btn {
  width: 217px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border: rgba(215, 215, 215, 1) 1px solid;
  color: #5f4aff;
}

</style>



// WEBPACK FOOTER //
// src/components/mainOrders/components/Fid.vue